import React from "react";
import Dashboard from "./Dashboard";
import { Route, Routes } from "react-router-dom";
import "../pages/css/index.css";
import Schools from "../pages/data/Schools";
import Students from "../pages/data/student/Students";
import Videos from "../pages/basicContent/Videos";
import Questions from "../pages/basicContent/questions/Questions";
import WorksheetPage from "../pages/basicContent/WorksheetPage";
import Modules from "../pages/data/Modules";
import LevelPage from "../pages/data/Level";
import ReadingMaterials from "../pages/basicContent/ReadingMaterials";
import ViewAllStudentBySchool from "../pages/data/ViewAllStudentBySchool";
import AddUsers from "../pages/users/AddUsers";
import jwt_decode from "jwt-decode";
import QrDataPage from "../pages/basicContent/QrData";
import Banner from "../pages/basicContent/banner/Banner";
import StudentAnalytics from "../pages/data/analytics/student_analytics";
import SchoolAnalytics from "../pages/data/analytics/school_analytics";
import RoadSafetyClub from "../pages/basicContent/RoadSafetyClub";
import AddAminModuleLevelPermission from "../pages/users/AddAminModuleLevelPermission";
import Notification from "../pages/basicContent/Notification/Notification";
import SupportTicket from "../pages/basicContent/SupportTicket";
import StudentTab from "../pages/data/StudentTab";

const Content = () => {
  const logCheck = localStorage.getItem("data");
  let decoded_data = "";
  if (logCheck != null) {
    decoded_data = jwt_decode(logCheck);
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        {/* <Route path='/dashboard' element={<Dashboard />} /> */}
        {decoded_data.user.role === "admin" && (
          <>
            <Route path="/add-users" element={<AddUsers />} />
            <Route path="/banners" element={<Banner />} />
            <Route path="/notifications" element={<Notification />} />
            <Route path="/add-admin" element={<AddAminModuleLevelPermission />} />
          </>
        )}
        <Route path="/students" element={<StudentTab />} />
        <Route path="/schools" element={<Schools />} />
        {decoded_data.user.role === "admin" && (
          <>
            {" "}
            <Route path="/modules" element={<Modules />} />
            <Route path="/levels" element={<LevelPage />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/readingmaterials" element={<ReadingMaterials />} />
            <Route path="/worksheets" element={<WorksheetPage />} />
            <Route path="/questions" element={<Questions />} />
            <Route path="/qr-data" element={<QrDataPage />} />
            <Route path="/studentanalytics" element={<StudentAnalytics />} />
            <Route path="/schoolanalytics" element={<SchoolAnalytics />} />
            <Route path="/road-safety-club" element={<RoadSafetyClub />} />
            <Route path="/support-ticket" element={<SupportTicket />} />
          </>
        )}
        <Route
          path="/view-all-students-by-school"
          element={<ViewAllStudentBySchool />}
        />
      </Routes>
    </>
  );
};

export default Content;
